/* eslint-disable class-methods-use-this */
/**
 * @name AccessibilityHelper
 * @description The `AccessibilityHelper` class provides helpful utilities
 * surrounding accessibility.
 */
class AccessibilityHelper {
  /**
   * @param event - a keydown event
   * @param callback - What to do when the event is triggered
   * @description Given keyboard event and a callback, checks to see if the event is
   * either `Spacebar` or `Enter`. If it is, it calls the callback.
   */
  handleKeydownEvent = (
    event: React.KeyboardEvent,
    callback: (keyboardEvent: React.KeyboardEvent) => void,
  ) => {
    const { key } = event;
    const enter = 'Enter';
    const spaceBar = ' ';
    if (key === enter || key === spaceBar) {
      callback(event);
    }
  };
}

export default new AccessibilityHelper();
